









import { Vue, Component } from 'vue-property-decorator';
/**
 * 无权限页面
 *
 * @author liyuyao
 * @date 1/06/2020
 */
@Component
export default class TicketBlank extends Vue {}
